import script from "./MyWorkOrderCreated.vue?vue&type=script&setup=true&lang=js"
export * from "./MyWorkOrderCreated.vue?vue&type=script&setup=true&lang=js"

import "./MyWorkOrderCreated.vue?vue&type=style&index=0&id=2cf208c9&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf208c9"]])

export default __exports__